import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { useAppState } from '../../services/state';

import '../../style/SidebarSimple.css';

const OverviewSidebar = ({ activeView, openCreateModal }) => {
  const appState = useAppState();
  const { isSidebarOpen } = appState.get();
  const closeSidebar = useCallback(() => appState.merge({ isSidebarOpen: false }), [appState]);

  const sideBarClasses = isSidebarOpen
    ? 'sidebar-simple openedSidebar'
    : 'sidebar-simple closedSidebar';

  return (
    <div className={sideBarClasses}>
      <div className="sidebar-simple-inner">
        <ul>
          <Link to="/boards" onClick={closeSidebar}>
            <li className={activeView === 'all' ? 'active' : ''}>All Boards</li>
          </Link>
          <Link to="/boards/own" onClick={closeSidebar}>
            <li className={activeView === 'own' ? 'active' : ''}>Owned by me</li>
          </Link>
          <Link to="/boards/shared" onClick={closeSidebar}>
            <li className={activeView === 'shared' ? 'active' : ''}>Shared with me</li>
          </Link>
          <Link to="/templates" onClick={closeSidebar}>
            <li className={activeView === 'templates' ? 'active' : ''}>Templates</li>
          </Link>
        </ul>
        <div className="sidebar-btn-section">
          <button className="btn btn-primary btn-icon" onClick={openCreateModal}>
            <span className="pr-3">
              <FiPlus size={'1.5rem'} />
            </span>
            Create new board
          </button>
        </div>
        {/*
        <div className="d-flex">
          <li className="py-3 px-3">Search</li>
          <div>Recent/Alphanunmeric dropdown</div>
          <div>All collaborators dropdown</div>
        </div>
        */}
      </div>
    </div>
  );
};

export default OverviewSidebar;
